import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import type { TextBubble } from '../interfaces'

export const useTextStore = defineStore('text', () => {
  const notes = ref<TextBubble[]>([])
  const searchQuery = ref('')

  const filteredNotes = computed(() => {
    return notes.value.filter((note) => {
      const searchLower = searchQuery.value.toLowerCase()
      return (
        note.title.toLowerCase().includes(searchLower) ||
        note.content.toLowerCase().includes(searchLower)
      )
    })
  })

  function setSearchQuery(query: string) {
    searchQuery.value = query
  }

  function removeNote(uuid: string) {
    notes.value = notes.value.filter((note) => note.uuid !== uuid)
  }

  return {
    notes,
    searchQuery,
    filteredNotes,
    setSearchQuery,
    removeNote,
  }
})
